export default "/img/connected.png"